import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Form } from 'react-bootstrap'
import { DashboardOutlined } from '@material-ui/icons'
import MasterPage from 'components/MasterPage';
import BootstrapTable from 'react-bootstrap-table-next';
import { api } from 'services';
import { Trans, useTranslation } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';
import Pagination from 'react-js-pagination';
import ExportTable from 'components/ExportTable';

function RulesByManufacturer(){
  const { t } = useTranslation();
  const defaultFilters = {
    __search: '',
    per_page: 10,
    page: 1,
    __fiscal_year: ''
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});

  function formatData(data){
    return data.map((item=>{
      function period(){try {return item.actual_period.period_type.name;} catch (error) {return ""}};
      return {
        id: item.id,
        manufacturer: item.alias,
        period: period(),
        start: item.start,
        rules: [...item.rules.map((r, key)=>{
          let period = `${r.period.type.name} ${r.period.position}`;
          // return (
          //   <tr style={{textAlign: 'center'}} key={key}>
          //     <th>{period}</th>
          //     <td>{r.expected_amount.replace(" - ","\n")}</td>
          //     <td>{r.real_amount.replace(" - ","\n")}</td>
          //     <td>{r.plan.replace(" - ","\n")}</td>
          //     <td>{r.execution.replace(" - ","\n")}</td>
          //     <td>{r.voucher.replace(" - ","\n")}</td>
          //     <td>{r.claim.replace(" - ","\n")}</td>
          //     <td>{r.refunds.replace(" - ","\n")}</td>
          //   </tr>
          // );
          return [
            period,
            r.expected_amount.replace(" - ","\n"),
            r.real_amount.replace(" - ","\n"),
            r.plan.replace(" - ","\n"),
            r.execution.replace(" - ","\n"),
            r.voucher.replace(" - ","\n"),
            r.claim.replace(" - ","\n"),
            r.refunds.replace(" - ","\n"),
          ]
        })]
      };
    }));
  }

  useEffect(() => {
    api.get("report-rules-by-manufacturer",{params:filters}).then(({data})=>{
      setData(formatData(data.data));
      setPagination(data.pagination);
    });
  },[filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters }
    if (reset) f = { ...defaultFilters, ...new_filters }
    setFilters(f);
  };

  const colConfig = {
    headerStyle: {
      textAlign: 'center',
      fontSize: '13px'
    },
    style: {
      textAlign: 'center',
      fontSize: '13px'
    }
  }
  const columns = [
    {
      dataField: 'id',
      text: '',
      headerStyle: {
        textAlign: 'center',
        width: "50px"
      },
      style: {
        textAlign: 'center',
        position: 'relative',
        padding: "0px"
      },
      formatter:(cel)=>{
        return (
          <div id={cel+"-expand-row-col"} className={"expand-row-col"}
            style={{
              position:"absolute", 
              left:"50%", top:"50%", 
              transform:"translate(-50%,-50%)",
              fontSize: "30px",
              fontWeight: "bold",
              fontFamily: "monospace"
            }}
          >+</div>
        );
      }
    },
    {
      dataField: 'manufacturer',
      text: 'Fabricante',
      ...colConfig
    },
    {
      dataField: 'period',
      text: 'Período',
      ...colConfig
    },
    {
      dataField: 'start',
      text: 'Início do Período',
      ...colConfig
    },
  ];

  const expandRow = {
    renderer: (row) => (
      <table>
        <thead>
          <tr style={{textAlign: 'center'}}>
            <th></th>
            <th>Verba prevista</th>
            <th>Verba Real</th>
            <th>Plano</th>
            <th>Execução</th>
            <th>Enviar comprovação</th>
            <th>Claim</th>
            <th>Receber reembolso</th>
          </tr>
        </thead>
        <tbody style={{textAlign: 'center'}}>
          {row.rules.map((item,key)=>{
            return (
              <tr key={key}>
                <td>{item[0]}</td>
                <td>{item[1]}</td>
                <td>{item[2]}</td>
                <td>{item[3]}</td>
                <td>{item[4]}</td>
                <td>{item[5]}</td>
                <td>{item[6]}</td>
                <td>{item[7]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    ),
    onlyOneExpanding: true,
    onExpand: (row, isExpand, rowIndex, e) => {
      if(isExpand){
        let btns = document.getElementsByClassName('expand-row-col');
        for(let i=0; i<btns.length; i++){
          let element = btns[i];
          element.innerText = "+";
        }
        let btn = document.getElementById(row.id+"-expand-row-col");
        if(btn){
          btn.innerText = "-";
        }
      } else {
        let btn = document.getElementById(row.id+"-expand-row-col");
        if(btn){
          btn.innerText = "+";
        }
      }
    },
  };

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">Relatório de Regras por Fabricante</h4>
        </Col>
        <Col md="12" className="mb-2">
          <ExportTable
            buttonText={'Exportar Lista'}
            fileName="rules-by-manufacturer-list-export"
            data={async (filters)=>{
              let _r = await api.get("report-rules-by-manufacturer",{params:filters});
              _r.data.data = formatData(_r.data.data);
              return _r;
            }}
            filters={filters}
            fields={[
              {type:"string",key:"manufacturer", label:"Fabricante"},
              {type:"string",key:"period", label:"Período"},
              {type:"string",key:"start", label:"Início do Período"},
            ]}
            expandRow={{
              field:"rules",
              cols:[
                "Posição no Período",
                "Verba prevista",
                "Verba Real",
                "Plano",
                "Execução",
                "Enviar comprovação",
                "Claim",
                "Receber reembolso",
              ],
              colspanHeader:[[1,2],[2,2],[3,2],[4,2],[5,2],[6,2],[7,2]],
              subHeader:[
                [1,["Início","Fim"]],
                [2,["Início","Fim"]],
                [3,["Início","Fim"]],
                [4,["Início","Fim"]],
                [5,["Início","Fim"]],
                [6,["Início","Fim"]],
                [7,["Início","Fim"]],
              ]
            }}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-between">
        <Col md="3">
          <Form.Group>
            <Form.Label>{t('label:records per page')}:</Form.Label>
            <Form.Control
              as="select"
              value={filters.per_page}
              onChange={(e) =>
                handleFilterChange({ per_page: e.target.value, page: 1 })
              }
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Control>
          </Form.Group>
        </Col>
        {/* <Col md="3">
          <Form.Group>
            <Form.Label>Ano Fiscal:</Form.Label>
            <Form.Control
              as="select"
              value={filters.__fiscal_year}
              onChange={(e) =>
                handleFilterChange({ __fiscal_year: e.target.value, page: 1 })
              }
            >
              <option disabled selected>Selecione o Ano fiscal</option>
              {fiscalYears.map(year => (
                <option>{year}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col> */}
        <Col md={3} className="ml-2">
          <Form.Group>
            <Form.Label>{t('label:search')}:</Form.Label>
            <DebounceInput
              element={Form.Control}
              debounceTimeout={500}
              onChange={(e) =>
                handleFilterChange({ __search: e.target.value, page: 1 })
              }
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <BootstrapTable
                columns={columns}
                keyField="id"
                data={data}
                bordered hover responsive striped
                rowStyle={{ fontSize: '13px' }}
                noDataIndication="--"
                classes="table-condensed w-100"
                wrapperClasses='table-responsive'
                expandRow={expandRow}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: pagination.from || '0' }} to{' '}
                {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={pagination.current_page}
                itemsCountPerPage={pagination.per_page}
                totalItemsCount={pagination.total}
                pageRangeDisplayed={5}
                onChange={(page) => handleFilterChange({ page })}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  );
}

export default MasterPage(RulesByManufacturer);